import React from 'react';
import PropTypes from 'prop-types';

const LearningNotStartedIcon = ({color = 'currentColor', ...props}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="8" fill="none" stroke={color} strokeWidth="1.6" />
  </svg>
);

LearningNotStartedIcon.propTypes = {
  color: PropTypes.string,
};

export default LearningNotStartedIcon;
